module.exports = __webpack_public_path__ + "static/media/bryond profits-logo-02.897e59df.png";